import FilterText from 'components/FilterText';
import { enumStatus } from 'enum/enumStatus';
import { ISalesChannel } from 'interfaces/ISalesChannel';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Col, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSalesChannelService } from 'services/salesChannelService';
import { UserAltSlash, Users } from 'styled-icons/fa-solid';
import { Edit, VerifiedUser } from 'styled-icons/material';
import * as S from './style';

const TableSalesChannel: React.FC = () => {
  const [salesChannels, setSalesChannel] = useState<ISalesChannel[] | null>(
    null
  );
  const { salesChannelService } = useSalesChannelService();
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    try {
      const result = await salesChannelService.getAll();
      setSalesChannel(result);
    } catch (error) {
      console.log(`error in TableUsers - function getData, error:${error}`);
    }
  }, [salesChannelService]);

  const dateFormat = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <S.Container>
      <FilterText
        placeholderInput="Nome do canal de venda"
        nameFieldToFilter="Name"
        dataToFilter={salesChannels}
        setDataToFilter={setSalesChannel}
      />
      {salesChannels && salesChannels.length > 0 && (
        <Row>
          <Col>
            <div className="table-thead-fixed">
              <Table className="table-striped text-center" responsive>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome</th>
                    <th>Desconto</th>
                    <th>Dt. Criação</th>
                    <th>Responsável</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {salesChannels.map((salechannel: ISalesChannel) => (
                    <tr key={salechannel.SalesChannelId}>
                      <td>
                        <span
                          title={String(salechannel.SalesChannelId)}
                          className="span-ellipsis "
                        >
                          {salechannel.SalesChannelId}
                        </span>
                      </td>
                      <td>{salechannel.Name}</td>
                      <td>{salechannel.MaxDiscount}</td>
                      <td>
                        {dateFormat.format(new Date(salechannel.CreatedDate))}
                      </td>
                      <td>
                        {salechannel.AdminUser
                          ? salechannel.AdminUser.Name
                          : 'N/A'}
                      </td>
                      <td>
                        <Button
                          type="button"
                          variant="outline-primary"
                          onClick={() =>
                            navigate('addEditSalesChannel', {
                              state: salechannel
                            })
                          }
                          title="Editar"
                        >
                          <Edit size={20} />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      )}
    </S.Container>
  );
};

export default TableSalesChannel;
